import type { AstNative } from "@omni/ads";

import { ContentDisplayTemplate } from "./ContentDisplay";
import { NativeClassicTemplate } from "./NativeClassic";

interface TemplateProps {
  ad: AstNative;
  layout: "small" | "large";
  advertisingConsent: boolean | null;
  open: (e: React.MouseEvent) => void;
  modal: JSX.Element | null;
}

const TemplateHandler = ({
  ad,
  layout,
  advertisingConsent,
  open,
  modal,
}: TemplateProps) => {
  if (!ad) {
    return null;
  }

  if (ad.desc2 === "brandstudio_native_ad") {
    return (
      <NativeClassicTemplate
        ad={ad}
        layout={layout}
        advertisingConsent={advertisingConsent}
        open={open}
        modal={modal}
      />
    );
  }

  return (
    <ContentDisplayTemplate
      ad={ad}
      layout={layout}
      advertisingConsent={advertisingConsent}
      open={open}
      modal={modal}
    />
  );
};

export { TemplateHandler };
export type { TemplateProps };
